import { render, staticRenderFns } from "./disponibilitaAlpi.vue?vue&type=template&id=05a0beec&scoped=true"
import script from "./disponibilitaAlpi.vue?vue&type=script&lang=js"
export * from "./disponibilitaAlpi.vue?vue&type=script&lang=js"
import style0 from "./disponibilitaAlpi.vue?vue&type=style&index=0&id=05a0beec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a0beec",
  null
  
)

export default component.exports